import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import classnames from 'classnames';

interface IProps {
  promotion: IGetPromotionResponse;
  daysLeft: null | number;
  ends: string;
  currency: string;
}

const BmsmChart = ({ promotion, daysLeft, ends, currency }: IProps): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$bmsmChart' });
  const { t: tPromo } = useTranslation('', { keyPrefix: '$common.$promotion' });

  const countdownIsActive = daysLeft <= 3;

  const countdownClass = (() => {
    if (daysLeft !== null && countdownIsActive) {
      if (daysLeft >= 0 && daysLeft < 1) {
        return 'ends-today';
      }
      if (daysLeft >= 1 && daysLeft < 2) {
        return 'ends-tomorrow';
      }
      if (daysLeft >= 2 && daysLeft < 3) {
        return 'ends-date';
      }
    }
    return '';
  })();

  const countdownCopy = (() => {
    if (daysLeft !== null && countdownIsActive) {
      if (daysLeft >= 0 && daysLeft < 1) {
        return 'hpEndsToday';
      }
      if (daysLeft >= 1 && daysLeft < 2) {
        return 'endsTomorrow';
      }
      if (daysLeft >= 2 && daysLeft < 3) {
        return 'ends';
      }
    }
    return '';
  })();

  return (
    <div className="stack">
      <div className="bmsm-chart">
        <span className={classnames('bmsm-countdown chart-headline-countdown', countdownClass)}>
          {countdownCopy && tPromo(countdownCopy, { ends: tPromo(ends) })}
          {countdownCopy !== '' ? '*' : ''}
        </span>
        <h1 className="bmsm-title">{t('title')}</h1>
        <table>
          <tbody>
            <tr>
              <td className="bmsm-header" />
            </tr>
            <tr>
              <td className="spend-header spend-col">{t('spend')}</td>
              <td className="save-header save-col">{t('save')}</td>
            </tr>
            {currency !== 'GBP' ? (
              <>
                <tr>
                  <td className="spend-col">{t('spend_1')}</td>
                  <td className="save-col">{t('save_1')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_2')}</td>
                  <td className="save-col">{t('save_2')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_3')}</td>
                  <td className="save-col">{t('save_3')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_4')}</td>
                  <td className="save-col">{t('save_4')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_5')}</td>
                  <td className="save-col">{t('save_5')}</td>
                </tr>
                <tr>
                  <td className="spend-col">{t('spend_6')}</td>
                  <td className="save-col">{t('save_6')}</td>
                </tr>
              </>
            ) : (
              <>
                <tr>
                  <td className="spend-col">£3,600</td>
                  <td className="save-col">£1,800 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£2,250</td>
                  <td className="save-col">£900 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£1,350</td>
                  <td className="save-col">£450 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£900</td>
                  <td className="save-col">£270 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£450</td>
                  <td className="save-col">£90 OFF</td>
                </tr>
                <tr>
                  <td className="spend-col">£225</td>
                  <td className="save-col">£22.5 OFF</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BmsmChart;
